import React from 'react'
import './listRentCTA.css'
import { Columns, Header } from '../../elements'
const ListingRentCTA = () => (
  <div className="split-cta-ride-list-block">
    <img
      className="split-cta-left-image"
      src="https://res.cloudinary.com/twisted-road/image/upload/fl_progressive,c_scale,q_auto,w_575,f_auto/v1566837658/frontend_assets/homepage-images/motorcycle-trim.jpg"
      alt="Rent a Motorcycle"
    />
    <img
      className="split-cta-right-image"
      src="https://res.cloudinary.com/twisted-road/image/upload/c_fill,q_auto,f_auto/v1566837658/frontend_assets/homepage-images/money-honey.jpg"
      alt="List a Motorcycle - Make Money!"
    />
    <div>
      <div>
        <Columns>
          <Columns.Column size={6} className="cta-ride">
            <div className="split-cta-column-inner-left">
              <p
                className="split-cta-h1 split-cta-ride-color is-uppercase has-text-weight-extra-bold is-size-2"
              >
                Ride
              </p>
              <p className="split-cta-p split-cta-ride-color is-size-5">
                I want to rent someone's motorcycle.
              </p>
              <a
                href="/search"
                className="button is-primary is-medium is-outlined is-yellow-btn"
              >
                Search Now
              </a>
            </div>
          </Columns.Column>
          <Columns.Column size={6} className="cta-list">
            <div className="split-cta-column-inner-right">
              <p
                className="has-text-black is-uppercase has-text-weight-extra-bold is-size-2 split-cta-h1"
              >
                List
              </p>
              <p className='is-size-5 split-cta-p'>
                I want to share my motorcycle.
              </p>
              <a
                href="/list-your-motorcycle"
                className="button is-black is-medium is-outlined"
              >
                Learn Now
              </a>
            </div>
          </Columns.Column>
        </Columns>
      </div>
    </div>
  </div>
)

export default ListingRentCTA
